var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a;
import { countryOptions, getDefaultCountry, isNumericPostalCode } from '../../../utils/countries';
import { handleKeydown, numericZipFields, alphanumericZipFields, makeUpdateZipFields, numericZipProps, alphanumericZipProps, } from '../../../utils/form';
import { makeFormContext } from './Form';
import { nameRegex } from '../../../utils/shared';
var defaultCountry = getDefaultCountry();
var billingName = {
    props: {
        id: 'billingName',
        name: 'billingName',
        autoComplete: 'ccname',
        autoCorrect: 'off',
        spellCheck: false,
    },
    blurError: function (value) {
        if (value && !value.match(nameRegex)) {
            return 'Your name is incomplete.';
        }
        return '';
    },
    changeError: function () { return ''; },
    required: true,
    fieldNames: ['billingAddress.firstName', 'billingAddress.lastName'],
};
var billingZip = __assign({ props: __assign({ id: 'billingZip', name: 'billingZip', placeholder: 'ZIP', autoComplete: 'billing postal-code', autoCorrect: 'off', spellCheck: false, onKeyDown: handleKeydown }, (isNumericPostalCode(defaultCountry) ? numericZipProps : alphanumericZipProps)), required: true, fieldNames: ['billingAddress.postalCode'] }, (isNumericPostalCode(defaultCountry) ? numericZipFields : alphanumericZipFields));
var billingCountry = {
    props: {
        id: 'billingCountry',
        name: 'billingCountry',
        placeholder: 'Country',
        autoComplete: 'billing country',
        autoCorrect: 'off',
        spellCheck: false,
        defaultValue: defaultCountry,
        onChange: makeUpdateZipFields(billingZip),
    },
    type: 'select',
    options: countryOptions,
    required: true,
    fieldNames: ['billingAddress.country'],
};
export var billingValues = {
    billingName: billingName,
    billingCountry: billingCountry,
    billingZip: billingZip,
};
export var BillingContext = (_a = makeFormContext({
    name: 'Billing',
    formValues: billingValues,
}), _a.Context), BillingProvider = _a.Provider, useBilling = _a.useForm;
//# sourceMappingURL=Billing.js.map